import { render, staticRenderFns } from "./ForumPark.vue?vue&type=template&id=c6d346c8&scoped=true"
import script from "./ForumPark.vue?vue&type=script&lang=js"
export * from "./ForumPark.vue?vue&type=script&lang=js"
import style0 from "./ForumPark.vue?vue&type=style&index=0&id=c6d346c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d346c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d346c8')) {
      api.createRecord('c6d346c8', component.options)
    } else {
      api.reload('c6d346c8', component.options)
    }
    module.hot.accept("./ForumPark.vue?vue&type=template&id=c6d346c8&scoped=true", function () {
      api.rerender('c6d346c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/synthesize/officialDocProcess/components/ForumPark.vue"
export default component.exports